let minFillMs = 900;
let enabled = true;

function normalizeMs(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 900;
  if (n < 0) return 0;
  if (n > 30000) return 30000;
  return Math.floor(n);
}

export function setAntiBotMinFillMs(value: unknown) {
  minFillMs = normalizeMs(value);
}

export function getAntiBotMinFillMs(): number {
  return minFillMs;
}

export function setAntiBotEnabled(value: unknown) {
  enabled = value !== false;
}

export function getAntiBotEnabled(): boolean {
  return enabled;
}

export function applyAntiBotSettings(payload: unknown) {
  const src = (payload && typeof payload === 'object') ? (payload as Record<string, unknown>) : {};
  const antiBot = (src.ANTI_BOT && typeof src.ANTI_BOT === 'object') ? (src.ANTI_BOT as Record<string, unknown>) : {};
  setAntiBotEnabled(antiBot.ENABLED);
  const v = antiBot.MIN_FILL_MS;
  if (v != null) {
    setAntiBotMinFillMs(v);
  }
}
